import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import axios from "../../utils/axiosInstance"; 
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import { useNavigate, useParams } from "react-router-dom";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ApproveModal = (props) => {
  const { open, setOpen, paymentId, transectionId, amount } = props;
  const useStyleData = makeStyles(stylesData);
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const navigate = useNavigate();
  const classesSweetAlert = useStyleData();
  const [alert, setAlert] = useState(null);
  const [formData, setFormData] = useState({
    adminRemark: "",
    transectionId: transectionId,
    amount:amount
  });
   const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    setFormData({
      ...formData,
      transectionId: transectionId,
      amount: amount
    });
  }, [transectionId]);
  const handleChanges = (e) => {
    setFormData({
      ...formData,
      [e.target.id]:
        e.target.type === "number" ? Number(e.target.value) : e.target.value,
    });
  };
  const handleSubmitApprove = async (event) => {
      setShowLoader(true); 
    event.preventDefault();  

    try {
      const token = localStorage.getItem("token");
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/approveWithdrawal/${paymentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      console.log("message",res?.data)
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {res?.data?.message}
            </span>
          }
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    } catch (err) {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {err?.response?.data?.message}
            </span>
          }
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    }
  };
  const hideAlert = () => {
    setAlert(null);
    navigate(`/admin/ManagePayout`);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Modal open={open} keepMounted onClose={handleClose}>
        <Box sx={style}>
          <div>
            <form onSubmit={handleSubmitApprove}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Approve Withdrawal Confirmation
              </Typography>
              <hr style={{ backgroundColor: "blue" }} />
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h3"
                style={{ fontSize: "17px" }}
              >
                Have you sent ${amount} ?
              </Typography>
              <textarea
                id="adminRemark"
                onChange={(e) => handleChanges(e)}
                type="text"
                maxlength="20"
                value={formData.adminRemark}
                style={{
                  padding: "10px",
                  backgroundColor: "#c2ced37a",
                  width: "100%",
                  height: "180px",
                  borderRadius: "10px",
                }}
              />
              <Button type="submit" loading={showLoader} disabled={showLoader}>
                Submit
              </Button>
            </form>
          </div>
          {alert}
        </Box>
      </Modal>
    </div>
  );
};
                                                                     
export default ApproveModal;
